import React, { Component, useEffect, useState } from "react";
import DashboardHeader from "@/components/DashboardHeader";
import BartenderPersonalInformation from "./BartenderPersonalInformation";
import BartenderScheduleForm from "./BartenderScheduleForm";
import BlockDates from "./BlockDates";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Alert from "@/components/alert/Alert";
import { GET, PATCH, POST } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import { bartenderListSave } from "@/redux/slices/bartenderSlice";
import defaultuser from "../../assets/images/defaultuser.jpg";
import DaysOfWeek from "@/constants/DaysOfWeek";
import { useAppSelector, useAppDispatch } from "@/hooks/hook";
import BartenderOneDaySchedule from "./BartenderOneDaySchedule";
import { IoMdArrowBack } from "react-icons/io";
import { upadateUser } from "@/redux/slices/userSlice";

interface BartenderSchedulePage {
  businessId?: string;
  isSuperAdmin?: boolean;
}

const BartenderSchedulePage: React.FC<BartenderSchedulePage> = ({
  isSuperAdmin,
  businessId,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const LoggedInBusinessId =
    useAppSelector((store) => store?.user?.business_id) || "";

  const id = location?.state?.id;
  const [bartenderList, setBartenderList] = useState<Array<any>>([]);
  const { refreshToken, email } = useAppSelector((store) => store.user);
  const {
    allBartenders,
    bartenderBlockedDate,
    bartenderSchedule,
    toggleUserActive,
  } = API_ROUTES;
  const [currentBartender, setCurrentBartender] = useState<object | any>("");
  const [bartendarSchedule, setBartenderSchedule] = useState<object | any>([]);
  const [change, setChange] = useState<boolean>(false);
  interface BartenderBlock {
    id: string;
    date: string;
    start_time: string;
    end_time: string;
    is_all_day: boolean;
  }
  const [bartenderBlocks, setBartenderBlocks] = useState<BartenderBlock[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [active, setActive] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const rerenderFun = () => {
    setChange(!change);
  };
  useEffect(() => {
    fetchData();
    // Clean-up function
    return () => {
      // Perform any clean-up (if needed)
    };
  }, []); // Empty dependency array to run effect only once on component mount

  useEffect(() => {
    currentBartender?.id && getBlocksById(currentBartender.id);
    fetchData();
  }, [change]);
  const fetchData = async () => {
    try {
      // fetch data from server
      setLoading(true);
      const result = await GET(
        `${allBartenders}${isSuperAdmin ? `?business_id=${businessId}` : ""}`,
        refreshToken
      );
      setBartenderList(result?.data);
      const admin = result?.data.filter((i: any) => i.is_admin == true);
      console.log("admin12", admin[0]);
      console.log("admin", email);
      if (admin.length > 0 && admin[0].email === email) {
        console.log("admin", admin[0]);
        dispatch(
          upadateUser({
            first_name: admin[0].first_name,
            last_name: admin[0].last_name,
            email: admin[0].email,
            avatar: admin[0].avatar,
          })
        );
      }
      if (id) {
        setCurrentBartender(
          result?.data?.find((b: any) => b?.id === (id as string))
        );
        getScheduleAndBlockById(id);
      } else {
        setCurrentBartender(result?.data[0]);
        getScheduleAndBlockById(result?.data[0].id);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  async function getScheduleById(id: string) {
    // get the schedule data using the current bartender id
    try {
      const result = await GET(`${bartenderSchedule}/${id}`, refreshToken);
      convertDataToSchedule(result?.data?.data);
      setActive(result?.data?.is_active);
    } catch (err) {
      console.log(err);
    }
  }

  async function getBlocksById(id: string) {
    // get the block dates data using the current bartender id
    try {
      const result = await GET(`${bartenderBlockedDate}/${id}`, refreshToken);
      setBartenderBlocks(result?.data);
    } catch (err) {
      console.log(err);
    }
  }

  async function getScheduleAndBlockById(id: string) {
    getScheduleById(id);
    getBlocksById(id);
  }

  interface Schedule {
    [key: string]: {
      active: boolean;
      start: string;
      end: string;
      isNew: boolean;
    };
  }
  function convertDataToSchedule(data: any[]) {
    // convert the data to a schedule object as our DB structure
    const schedule: Schedule = {};
    DaysOfWeek.forEach((day, index) => {
      const foundDay = data.find((obj: any) => obj.weekday === index);
      if (foundDay) {
        let startTime = foundDay.start_time;
        let endTime = foundDay.end_time;
        // Convert "24:00:00"
        if (startTime === "24:00:00") {
          startTime = "00:00";
        }
        if (endTime === "24:00:00") {
          endTime = "00:00";
        }
        schedule[day] = {
          isNew: false,
          active: foundDay.is_enable,
          start: startTime.slice(0, 5),
          end: endTime.slice(0, 5),
        };
      } else {
        schedule[day] = {
          isNew: true,
          active: false,
          start: "09:00",
          end: "18:00",
        }; // Default values if not found
      }
    });

    setBartenderSchedule(schedule);
  }

  const updateBartenderInfo = (info: {
    first_name: string;
    last_name: string;
    email: string;
    phone_number: string | null | undefined;
  }) => {
    console.log("BartenderINfo", info);
    const list = [...bartenderList];
    const index = bartenderList.findIndex(
      (item) => item?.id == currentBartender.id
    );
    list[index] = { ...currentBartender, ...info };
    setBartenderList(list);
  };

  // update bartender schedule

  async function convertScheduleData(data: any): Promise<any[]> {
    const result: any[] = [];
    DaysOfWeek.forEach((day, index) => {
      const start_time = data[day].start + ":00";
      const end_time = data[day].end + ":00";
      const isNew = data[day].isNew;
      const is_enable = data[day].active;
      result.push({ is_enable, weekday: index, start_time, end_time, isNew });
    });
    return result;
  }

  //update block dates
  // const updateBlockDates = (data: Date[]) => {
  //   console.log(data)
  // };

  // update schedule in DB now
  const updateScheduleFun = async (newSchedule: any) => {
    try {
      // if there is required to update the schedule
      setLoading(true);
      const data = await convertScheduleData(newSchedule);

      const response = await PATCH(
        `${bartenderSchedule}/${currentBartender.id}`,
        { data, businessId: isSuperAdmin ? businessId : LoggedInBusinessId },
        refreshToken
      );
      setActive(response?.data?.is_active);
      setLoading(false);
      Alert({ message: response?.data?.message });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const updateActive = async (status: boolean) => {
    // update active and not active status for bartender
    setActive(status);
    try {
      const body = {
        is_active: status,
        businessId: isSuperAdmin ? businessId : LoggedInBusinessId,
      };
      const result = await POST(
        `${toggleUserActive}/${currentBartender.id}`,
        body,
        refreshToken
      );
      convertDataToSchedule(result?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <div className=" pb-2 pt-5 mb-3 flex items-start md:items-center md:gap-16 gap-2  justify-between">
        <div className="flex gap-2 items-center">
          {/* <Link to={'/'}  className="bg-white p-2 rounded-full cursor-pointer">
          <IoMdArrowBack />
        </Link> */}
          <p className="md:text-3xl text-xl text-gray-800 font-semibold mb-2">
            Scheduler
          </p>
        </div>
        <div className="flex items-center   flex-wrap gap-1">
          {[...bartenderList].map((item, index) => {
            return (
              <div
                title={item.first_name + " " + item.last_name}
                key={index}
                className="flex flex-col items-center gap-1"
              >
                <img
                  id="{index}_img"
                  onClick={() => {
                    setCurrentBartender(item), getScheduleAndBlockById(item.id);
                  }}
                  className={`object-cover w-10 h-10 rounded-full cursor-pointer ${
                    currentBartender.id === item?.id
                      ? "border-[4px] w-12 h-12  border-primary-red"
                      : ""
                  }`}
                  src={
                    item?.avatar?.includes("https://")
                      ? item?.avatar
                      : defaultuser
                  }
                  alt="bartendar"
                />
                {currentBartender.id === item?.id && (
                  <div className="bg-primary-red w-10/12  h-[2px] rounded-md"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-5">
        {/* Left */}
        <div className="md:w-6/12  w-full">
          <div className="flex flex-col ">
            {currentBartender && (
              <BartenderPersonalInformation
                isSuperAdmin={isSuperAdmin}
                navigateEdit={() => {
                  navigate("/addbartender", {
                    state: { data: currentBartender, isEdit: true },
                  });
                }}
                id={currentBartender?.id}
                img={currentBartender?.avatar}
                first_name={currentBartender.first_name}
                last_name={currentBartender.last_name}
                email={currentBartender.email}
                phone_number={currentBartender?.phone_number}
                updateBartenderInfo={updateBartenderInfo}
                currentBartender={currentBartender}
                rerenderFun={rerenderFun}
              />
            )}
            {/* Dlock And One days */}
            <div className="flex gap-2 flex-wrap ">
              {currentBartender && (
                <div className="lg:flex-1  w-full">
                  <BlockDates
                    id={currentBartender?.id}
                    bartenderBlocks={bartenderBlocks}
                    setChange={setChange}
                    change={change}
                    // updateBlockDates={updateBlockDates}
                  />
                </div>
              )}
              {currentBartender && (
                <div className=" lg:flex-1 w-full">
                  <BartenderOneDaySchedule
                    id={currentBartender?.id}
                    bartenderBlocks={bartenderBlocks}
                    setChange={setChange}
                    change={change}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Right */}
        <div className="md:w-6/12 w-full">
          {bartendarSchedule && (
            <BartenderScheduleForm
              active={active}
              updateActive={updateActive}
              updateScheduleFun={updateScheduleFun}
              bartenderSchedule={bartendarSchedule}
            />
          )}
        </div>
      </div>
      {/* Update Bartender information  */}
    </div>
  );
};

export default BartenderSchedulePage;
